import { createSlice } from '@reduxjs/toolkit';
const initState = {
  lead: {},
  quote: {},
  proposal: {},
};

export const insuranceSlice = createSlice({
  name: 'insDetails',
  initialState: initState,
  reducers: {
    UPDATE_LEADS: (state, action) => {
      return {
        ...state,
        lead: {
          ...state.lead,
          ...action.payload,
        },
      };
    },
    UPDATE_QUOTES: (state, action) => {
      return {
        ...state,
        quote: { ...state.quote, ...action.payload },
      };
    },
  },
});

export const { UPDATE_LEADS, UPDATE_QUOTES } = insuranceSlice.actions;

export default insuranceSlice.reducer;
